var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { UseHeartbeats } from "../components/HooksWrapper";
import { Links } from "../components/Link";
import { MappedImage } from "../components/Mappings";
export var Room = function (room) {
    var _a = room.userData, eventName = _a.eventName, fullName = _a.fullName, regId = _a.regId;
    var links = room.links, extras = room.extras, background = room.background, inside = room.inside, rest = __rest(room
    // Force Typescript to ingnore DIV properties and append path
    , ["links", "extras", "background", "inside"]);
    // Force Typescript to ingnore DIV properties and append path
    var route = { path: room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "") };
    return React.createElement("div", __assign({ key: room.name, style: { position: "relative" } }, rest, route),
        React.createElement(React.Fragment, null,
            React.createElement(UseHeartbeats, { page: room.name, data: { eventName: eventName, fullName: fullName, regId: regId } }),
            React.createElement(MappedImage, { imageURL: background },
                React.createElement(Links, { links: links, roomName: room.name }),
                inside || false ? inside : null),
            extras));
};
//# sourceMappingURL=Room.js.map